import React, { useState, useEffect, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import { useLocation } from "react-router-dom";
import Accordion from "./accordion/Accordion";
import { motion, AnimatePresence } from "framer-motion";
import Home from "./home";
import Wallet from "./Wallet";
import Acquire from "./acquire";
import Redeem from "./redeem";
import Burning from "./burning";
import Inventory from "./inventory";
import Staking from "./staking";
import ButtonHoverAnimation from "./button/ButtonHoverAnimation";
import { useAccount } from "wagmi";
import LiveRate from "./liverate";
import Metadata from "./metadata";

const Wrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";
  const { address, account } = useAccount();

  const previousPathRef = useRef(location.pathname);

  useEffect(() => {
    const noRedirectToConnectedWalletPaths = [
      "/acquire-brain",
      "/my-inventory",
      "/staking",
      "/burning",
      "/burning-redeem",
      "/configure-metadata",
    ];

    if (!address) {
      if (location.pathname !== "/") {
        navigate("/");
      }
    } else if (
      !noRedirectToConnectedWalletPaths.includes(location.pathname) &&
      location.pathname !== "/connected-wallet"
    ) {
      navigate("/connected-wallet");
    }

    previousPathRef.current = location.pathname;
  }, [address, navigate]);

  const [isFaqOpen, setIsFaqOpen] = useState(false);

  const toggleFAQ = (event) => {
    setIsFaqOpen((prevState) => !prevState);
    event.preventDefault();
  };

  useEffect(() => {
    // Add or remove class to the body tag based on dropdown state
    if (isFaqOpen) {
      document.body.classList.add("faq-open");
    } else {
      document.body.classList.remove("faq-open");
    }
  }, [isFaqOpen]);

  return (
    <>
      <ButtonHoverAnimation />
      <div data-barba="wrapper">
        <div className="overlay-faq" onClick={toggleFAQ}></div>

        <div className="position-absolute px-3 py-2 px-sm-4 py-sm-3 px-md-5 py-md-4 mx-xl-4 opacity-load start-0 end-0">
          <div className="w-100 d-flex justify-content-between align-items-center">
            <div className="nav-width">
              <Link to="/" className="link-inherit d-block">
                <svg
                  className="logo"
                  viewBox="0 0 152 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5391 0.608398C17.4767 0.608398 23.3424 2.07796 23.3424 8.08301C23.3424 10.4764 22.2873 12.7442 20.0508 13.836C22.7515 14.9277 24.1021 17.5733 24.1021 20.3867C24.1021 26.6439 19.5445 28.4074 14.0585 28.4074H0.638672V0.608398H12.5391ZM5.78714 2.4561H2.49553V26.5597H5.78714V2.4561ZM16.5483 2.95992C15.7886 2.66594 14.8602 2.4561 14.0585 2.4561H7.64401V13.0382H13.763C14.6914 13.0382 15.6199 12.9963 16.5483 12.9121V2.95992ZM16.5483 15.0119C15.6199 14.9281 14.6914 14.8859 13.763 14.8859H7.64401V26.5597H14.1006C14.9023 26.5597 15.7465 26.4336 16.5483 26.2238V15.0119ZM18.4052 12.8702C20.5575 11.9045 21.4859 10.6025 21.4859 8.16716C21.4859 5.89942 20.4308 4.3457 18.4052 3.33807V12.8702ZM18.4052 26.2238C21.1905 25.2158 22.2456 23.3685 22.2456 20.4709C22.2456 17.9933 20.9375 15.6418 18.4052 15.0538V26.2238Z"
                    fill="currentColor"
                  />
                  <path
                    d="M48.3784 21.7385V7.13848H52.8584C54.2718 7.13848 55.3918 7.47848 56.2184 8.15848C57.0451 8.82514 57.4584 9.73848 57.4584 10.8985C57.4584 11.5518 57.3118 12.1185 57.0184 12.5985C56.7251 13.0785 56.3251 13.4518 55.8184 13.7185C55.3251 13.9851 54.7518 14.1185 54.0984 14.1185V14.0385C54.8051 14.0251 55.4318 14.1585 55.9784 14.4385C56.5384 14.7051 56.9784 15.1051 57.2984 15.6385C57.6318 16.1718 57.7984 16.8185 57.7984 17.5785C57.7984 18.4185 57.6051 19.1518 57.2184 19.7785C56.8318 20.4051 56.2851 20.8918 55.5784 21.2385C54.8851 21.5718 54.0518 21.7385 53.0784 21.7385H48.3784ZM50.8184 19.6585H52.9184C53.6518 19.6585 54.2251 19.4651 54.6384 19.0785C55.0651 18.6785 55.2784 18.1385 55.2784 17.4585C55.2784 16.7785 55.0651 16.2318 54.6384 15.8185C54.2251 15.3918 53.6518 15.1785 52.9184 15.1785H50.8184V19.6585ZM50.8184 13.1585H52.8184C53.4851 13.1585 54.0051 12.9851 54.3784 12.6385C54.7651 12.2785 54.9584 11.7918 54.9584 11.1785C54.9584 10.5651 54.7651 10.0851 54.3784 9.73848C54.0051 9.39181 53.4851 9.21848 52.8184 9.21848H50.8184V13.1585Z"
                    fill="currentColor"
                  />
                  <path
                    d="M63.3306 21.7385L67.0106 7.13848H70.2306L73.9306 21.7385H71.3706L70.5706 18.1985H66.6906L65.8906 21.7385H63.3306ZM67.1506 16.1585H70.1106L69.2306 12.2385C69.0839 11.5851 68.9573 10.9985 68.8506 10.4785C68.7439 9.94514 68.6706 9.55848 68.6306 9.31848C68.5906 9.55848 68.5173 9.94514 68.4106 10.4785C68.3173 10.9985 68.1906 11.5785 68.0306 12.2185L67.1506 16.1585Z"
                    fill="currentColor"
                  />
                  <path
                    d="M84.4628 21.9385C83.4628 21.9385 82.5961 21.7718 81.8628 21.4385C81.1295 21.1051 80.5628 20.6318 80.1628 20.0185C79.7761 19.3918 79.5761 18.6585 79.5628 17.8185H82.0628C82.0628 18.4185 82.2761 18.8918 82.7028 19.2385C83.1428 19.5718 83.7361 19.7385 84.4828 19.7385C85.2028 19.7385 85.7628 19.5718 86.1628 19.2385C86.5761 18.9051 86.7828 18.4451 86.7828 17.8585C86.7828 17.3651 86.6361 16.9385 86.3428 16.5785C86.0628 16.2051 85.6561 15.9518 85.1228 15.8185L83.4428 15.3585C82.2961 15.0651 81.4095 14.5385 80.7828 13.7785C80.1695 13.0185 79.8628 12.0985 79.8628 11.0185C79.8628 10.1918 80.0495 9.47181 80.4228 8.85848C80.7961 8.24514 81.3228 7.77181 82.0028 7.43848C82.6961 7.10514 83.5095 6.93848 84.4428 6.93848C85.8561 6.93848 86.9761 7.30514 87.8028 8.03848C88.6295 8.75848 89.0495 9.73181 89.0628 10.9585H86.5628C86.5628 10.3851 86.3761 9.93848 86.0028 9.61848C85.6295 9.28514 85.1028 9.11848 84.4228 9.11848C83.7695 9.11848 83.2628 9.27181 82.9028 9.57848C82.5428 9.88514 82.3628 10.3185 82.3628 10.8785C82.3628 11.3851 82.4961 11.8185 82.7628 12.1785C83.0428 12.5251 83.4428 12.7718 83.9628 12.9185L85.7028 13.3985C86.8628 13.6918 87.7495 14.2185 88.3628 14.9785C88.9761 15.7251 89.2828 16.6518 89.2828 17.7585C89.2828 18.5851 89.0828 19.3185 88.6828 19.9585C88.2828 20.5851 87.7228 21.0718 87.0028 21.4185C86.2828 21.7651 85.4361 21.9385 84.4628 21.9385Z"
                    fill="currentColor"
                  />
                  <path
                    d="M95.975 21.7385V7.13848H104.735V9.31848H98.435V13.1185H104.035V15.2785H98.435V19.5585H104.735V21.7385H95.975Z"
                    fill="currentColor"
                  />
                  <path
                    d="M111.507 21.7385V7.13848H115.847C116.834 7.13848 117.687 7.32514 118.407 7.69848C119.14 8.07181 119.707 8.59848 120.107 9.27848C120.507 9.95848 120.707 10.7651 120.707 11.6985V17.1585C120.707 18.0785 120.507 18.8851 120.107 19.5785C119.707 20.2585 119.14 20.7918 118.407 21.1785C117.687 21.5518 116.834 21.7385 115.847 21.7385H111.507ZM114.007 19.4385H115.847C116.567 19.4385 117.141 19.2385 117.567 18.8385C117.994 18.4251 118.207 17.8651 118.207 17.1585V11.6985C118.207 11.0051 117.994 10.4585 117.567 10.0585C117.141 9.64514 116.567 9.43848 115.847 9.43848H114.007V19.4385Z"
                    fill="currentColor"
                  />
                  <path
                    d="M126.499 21.7385L130.179 7.13848H133.399L137.099 21.7385H134.539L133.739 18.1985H129.859L129.059 21.7385H126.499ZM130.319 16.1585H133.279L132.399 12.2385C132.253 11.5851 132.126 10.9985 132.019 10.4785C131.913 9.94514 131.839 9.55848 131.799 9.31848C131.759 9.55848 131.686 9.94514 131.579 10.4785C131.486 10.9985 131.359 11.5785 131.199 12.2185L130.319 16.1585Z"
                    fill="currentColor"
                  />
                  <path
                    d="M143.392 21.7385V19.5385H146.332V9.33848H143.392V7.13848H151.792V9.33848H148.852V19.5385H151.792V21.7385H143.392Z"
                    fill="currentColor"
                  />
                </svg>
              </Link>
            </div>

            <div className="d-none d-md-block">
              <LiveRate />
            </div>

            <div className="nav-width d-flex justify-content-end position-relative z-2">
              <w3m-button />
            </div>
          </div>
        </div>

        <AnimatePresence mode="wait">
          <Routes location={location} key={location.key}>
            <Route
              path="/"
              element={
                <FadeDownAnimation layoutId="home">
                  <Home />
                </FadeDownAnimation>
              }
            />
            <Route
              path="/connected-wallet"
              element={
                <FadeDownAnimation layoutId="wallet">
                  <Wallet />
                </FadeDownAnimation>
              }
            />
            <Route
              path="/acquire-brain"
              element={
                <FadeDownAnimation layoutId="acquire">
                  <Acquire />
                </FadeDownAnimation>
              }
            />
            <Route
              path="/burning-redeem"
              element={
                <FadeDownAnimation layoutId="redeem">
                  <Redeem />
                </FadeDownAnimation>
              }
            />

            <Route
              path="/burning"
              element={
                <FadeDownAnimation layoutId="burning">
                  <Burning />
                </FadeDownAnimation>
              }
            />
            <Route
              path="/my-inventory"
              element={
                <FadeDownAnimation layoutId="inventory">
                  <Inventory />
                </FadeDownAnimation>
              }
            />
            <Route
              path="/staking"
              element={
                <FadeDownAnimation layoutId="staking">
                  <Staking />
                </FadeDownAnimation>
              }
            />
            <Route
              path="/configure-metadata"
              element={
                <FadeDownAnimation layoutId="configureMetadata">
                  <Metadata />
                </FadeDownAnimation>
              }
            />
          </Routes>
        </AnimatePresence>
        {isHomePage ? (
          <></>
        ) : (
          <footer className="px-3 px-sm-4 px-md-5 py-4 mx-xl-4 bottom-0 opacity-load position-relative">
            <div className="w-100 d-flex justify-content-between align-items-center">
              <div></div>
              <div className="d-inline-block position-relative">
                <Link
                  className="openFaq underline-on-hover-2"
                  onClick={toggleFAQ}
                >
                  <span>FAQs</span>
                </Link>
                <div className="perspective">
                  <div className="faq-dropdown">
                    <div className="box-head py-4 px-3 px-md-4">
                      <div className="px-md-2 py-md-1">
                        <small className="font-mono text-uppercase muted d-block mb-2">
                          Frequently asked questions
                        </small>
                        <div className="fs-3 mb-0 lh-1 text-uppercase">
                          FAQs
                        </div>
                      </div>
                    </div>
                    <hr className="my-0 border-green" />
                    <div>
                      <Accordion />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        )}
        <div className="overlay-canvas"></div>
      </div>
    </>
  );
};

const FadeDownAnimation = ({ children, layoutId }) => (
  <motion.div
    layoutId={layoutId}
    initial={{
      opacity: 0,
      y: -40,
      filter: "blur(0px)",
      transition: { delay: 0.5 },
    }}
    animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
    exit={{ opacity: 0, y: 40, filter: "blur(12px)" }}
    transition={{ ease: "easeOut", duration: 0.8 }}
  >
    {children}
  </motion.div>
);

export default Wrapper;
